export default __webpack_public_path__ + "static/media/alina_4.2c126840.webp";